import { defineStore } from 'pinia'
import { ref } from 'vue'
import { type DashboardDialogContent } from './dashboard_nav.types'

export const useDashboardNavStore = defineStore('dashboardNav', () => {
  /** global state used for conditionally rendering content pages in the `Dashboard` component. */
  const dashboardDialogContent = ref<DashboardDialogContent | undefined>("notifications")

  /** global state used for conditionally display the dashboard dialog. */
  const showDashboard = ref(false)

  /** Sets the content for the dashboard dialog. */
  function setDashboardDialogContent(payload: DashboardDialogContent | undefined) {
    dashboardDialogContent.value = payload
  }

  /** Sets the visibility of the dashboard dialog. */
  function setShowDashboard(payload: boolean) {
    showDashboard.value = payload
  }

  return {
    dashboardDialogContent,
    showDashboard,
    setDashboardDialogContent,
    setShowDashboard,
  }
})
